/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

// local imports
import { AuthActions } from '@auth/store/actions';
import { User } from '@models/user.model';

export const LOGIN_FEATURE_KEY = 'login';

export interface LoginState {
  user: User | null;
  authToken: string | null;
  redirectUrl: string | null;
  checkingCredentials: boolean;
  errorMessage: string | null;
  sessionExpired: boolean;
}

const initialState: LoginState = {
  user: null,
  authToken: null,
  redirectUrl: null,
  errorMessage: null,
  checkingCredentials: false,
  sessionExpired: false,
};

const reducer = createReducer(
  initialState,

  on(AuthActions.resetLogin, (state) => ({
    ...state,
    ...initialState,
    sessionExpired: state.sessionExpired,
  })),

  on(AuthActions.login, (state) => ({
    ...state,
    checkingCredentials: true,
    errorMessage: null,
  })),
  on(AuthActions.loginSuccess, (state, { payload }) => ({
    ...state,
    user: payload.user,
    authToken: payload.token,
    errorMessage: null,
    sessionExpired: false,
  })),
  on(AuthActions.loginFailure, (state, { payload }) => ({
    ...state,
    checkingCredentials: false,
    errorMessage: payload.errorMessage,
  })),
  on(AuthActions.setSessionAsExpired, (state) => ({
    ...state,
    sessionExpired: true,
  }))
);

export function loginReducer(state: LoginState | undefined, action: Action): LoginState {
  return reducer(state, action);
}
